/* eslint-disable */
export default {
  cancel: '取消',
  pmiChangeConfirmed: '更改',
  pmiChangeConfirmTitle: '是否更改个人会议设置？',
  pmiChangeConfirmContext:
    '更改这些设置会影响使用您的个人会议 ID 或名称的所有会议，包括您已安排的会议。',
  updatePassword: '更新密码',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
